export default function Footer({ children, className = "", style = {} }) {
    return (
      <footer className={`footer ${className}`} style={style}>
        {children}
      </footer>
    );
  }
  